import logger from "../../../logging/logger";

export const transformErrors = (errors) => {
  return errors.map((error) => {
    logger.error("err:", error);
    if (error.name === "minItems" && error.property === ".to.taetigkeit") {
      error.message = `Es muss mindestens ${error.params.limit} Bereich ausgewählt sein.`;
    }
    if (error.name === "required" && error.property === ".to.email") {
      error.message = "E-Mail Adresse ist erforderlich";
    }
    if(error.name === "oneOf"){
        error.message = "Bitte wählen Sie einen gültigen Empfängertyp aus";
    }
    return error;
  });
};

export let comingUpExamination = {
  label: "Untersuchungen stehen an",
  desc: "",
  form_schema: {
    definitions: {
      taetigkeit: {
        title: "für welchen Tätigkeitsbereich",
        minItems: 1,
        type: "array",
        uniqueItems: true,
        description:
          "Nur ausgewählte Tätigkeitsbereiche werden geprüft (für alle Tätigkeitsbereiche, bitte auch Alle markieren)",
          items: {
            anyOf: [
              { const: "1", title: "My Foo" }
            ],
          },
        },
        untersuchungen: {
          title: "für welche Untersuchung",
          type: "array",
          uniqueItems: true,
          description: "Nur ausgewählte Untersuchugen werden geprüft (für alle, bitte Alle markiern)",
          items: {
            anyOf: [
              { const: "1", title: " " }
            ],
          }
        },
        "Verbindung": {
          type: "object",
          title: "",
          properties: {
            "Filter": {
              enum: [
                "Nach Tätigkeitsbereich",
                "Nach Untersuchungen",
                "Nach Untersuchungen aus dem Tätigkeitsbereich"
              ]
            }
          },
          "allOf": [
            {
              "if": {
                properties: {
                  "Filter": {
                    const: "Nach Tätigkeitsbereich"
                  }
                }
              },
              "then": {
                properties: {
                  taetigkeit: { $ref: "#/definitions/taetigkeit" },
                }
              }
            },
            {
              "if": {
                properties: {
                  "Filter": {
                    const: "Nach Untersuchungen"
                  }
                }
              },
              "then": {
                properties: {
                  untersuchungen: { $ref: "#/definitions/untersuchungen" },
                }
              }
            },
            {
              "if": {
                properties: {
                  "Filter": {
                    const: "Nach Untersuchungen aus dem Tätigkeitsbereich"
                  }
                }
              },
              "then": {
                properties: {
                  taetigkeit: { $ref: "#/definitions/taetigkeit" },
                  untersuchungen: { $ref: "#/definitions/untersuchungen" }
                }
              }
            },
            {
              "required": [ "Filter" ]
            }
          ]
        },
    },
    type: "object",
    required: ["to", "when"],
    properties: {
      cron: {
        title: "In welchem Intervall soll die E-Mail gesendet werden?",
        type: "string",
        description:
          "CRON Zeiteinstellung ( https://crontab.guru/ ) DEFAULT = '00 04 1 * *'",
        default: "00 04 1 * *",
      },
      from: {
        type: "string",
        title: "Sender E-Mail",
        default: "info@divoka.de",
      },
      to: {
        type: "object",
        title: "Empfänger",
        oneOf: [
          {
            title: "Mitarbeiter",
            type: "object",
            properties: {
              type: {
                type: "string",
                enum: ["mitarbeiter"],
                default: "mitarbeiter"
              },
              mitarbeiter: {
                type: "string",
                title: "E-Mail",
                "ui:placeholder": "E-Mail geht an den betreffenden Mitarbeiter",
                readOnly: true,
              },
              "Begrenzung": {$ref: "#/definitions/Verbindung"} ,
            },
            required: ["type", "Begrenzung"],
          },
          {
            title: "Individuell",
            type: "object",
            properties: {
              type: {
                type: "string",
                enum: ["individuell"],
                default: "individuell"
              },
              email: {
                type: "string",
                title: "E-Mail Adresse",
              },
              "Begrenzung": {$ref: "#/definitions/Verbindung"},
            },
            required: ["type", "email", "Begrenzung"],
          },
        ],
      },
      when: {
        title: "Welcher Zeitraum soll beachtet werden?",
        type: "object",
        properties: {
          zahl: {
            title: "x vor Ablauf",
            type: "number",
            description:
              "Ablauf ist das Datum wann die Untersuchung nicht mehr Gültig ist.",
          },
          auswahl: {
            title: "Tage/Monate",
            type: "string",
            enum: ["Tage", "Monate"],
          },
        },
        required: ["zahl", "auswahl"],
      },
      subject: {
        type: "string",
        title: "Betreff",
      },
      text: {
        type: "string",
        title: "E-Mail Text",
      },
    },
  },
  uiSchema: {
    text: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5,
      },
    },
    readonly: {
      "ui:readonly": true,
    },
    cron: {
      "ui:help": "Um 04:00, an Tag 1 des Monats",
    },
    to: {
      "ui:classNames": "si-oneOf",
      mitarbeiter: {
        "ui:placeholder": "E-Mail geht an den betreffenden Mitarbeiter",
      },
      type: {
        "ui:widget": "hidden"
      }
    },
  },
  function: trigger,
  transformErrors: transformErrors,
  mail_context: (content) => {
    const isMitarbeiter = content?.to?.type === "mitarbeiter" || content?.to?.mitarbeiter !== undefined;
    if (isMitarbeiter) {
      return ["{mitarbeitername}", "{untersuchung-list}"];
    }
    // Individueller Empfänger
    return ["{ma-list}", "{untersuchung-list}"];
  },
  context_functions: () => [],
};

export function trigger() {
  logger.log("comingUpExamination Trigger!!!!");
}
